import React from "react";
import parse, { domToReact } from "html-react-parser";
import { removeEUPrivateShieldProvatePolicyLink } from "../../util/common";
import LogoContainer from "../common/LogoContainer";
import { useSelector } from "react-redux";
import { ApplicationState } from "../../store";

const TermsAndConditionDialog = (props: any) => {
    const showLogoOnRegistrationScreens: any = useSelector((state: ApplicationState) =>
        state.configurationState && state.configurationState.configuration.partnerConfig.registration
            ? state.configurationState.configuration.partnerConfig.registration.includePartnerLogo
            : false
    );
    const printDiv = () => {
        let content: any = document.getElementById("printTC");
        let printDoc: any = window.open("", "Print-Window");
        if (printDoc) {
            printDoc.document.open();
            printDoc.document.write('<html><body onload="window.print()">' + content.innerHTML + "</body></html>");
            printDoc.document.close();
            setTimeout(() => {
                printDoc.close();
            }, 10);
        }
    };
    const options = {
        replace: ({ attribs, children }: any) => {
            if (!attribs) return;

            if (attribs.hasOwnProperty("class")) {
                if (attribs.class.indexOf("pdfPrint_icons") !== -1) {
                    return (
                        <a
                            href="/"
                            onClick={(e) => {
                                e.preventDefault();
                                printDiv();
                            }}
                        >
                            <i className="las la-print" style={{ fontSize: "32px", float: "right" }}></i>
                        </a>
                    );
                }
            }

            if (attribs.hasOwnProperty("href")) {
                if (attribs.href.indexOf("window.print()") !== -1) {
                    return <a href="javascript:window.print();">{domToReact(children, options)}</a>;
                }

                if (
                    attribs.href.indexOf("privacy-policy") !== -1 ||
                    attribs.href.indexOf("canadian-privacy-policy") !== -1 ||
                    attribs.href.indexOf("PrivacyPolicy") !== -1
                )
                    return (
                        <a href="/privacy" target="_blank">
                            {domToReact(children, options)}
                        </a>
                    );

                if (attribs.href.indexOf("EUUSPrivacyShield") !== -1 || attribs.href.indexOf("privacy-shield-policy") !== -1)
                    return <a href="/privacy-shield">{domToReact(children, options)}</a>;

                if (attribs.href.indexOf("EUGDPRNotice") !== -1 || attribs.href.indexOf("eu-gdpr-fair-processing-notice") !== -1)
                    return <a href="/gdpr">{domToReact(children, options)}</a>;

                if (attribs.href.indexOf("ccpa-addendum") !== -1 || attribs.href.indexOf("CCPAAddendum") !== -1)
                    return <a href="/ccpa">{domToReact(children, options)}</a>;

                if (attribs.href.indexOf(window.location.hostname) === -1)
                    return (
                        <a href={attribs.href} target="_blank">
                            {domToReact(children, options)}
                        </a>
                    );
            }
        },
    };

    return (
        <React.Fragment>
            <div className="dialog-body">
                {showLogoOnRegistrationScreens && (
                    <div className="col-xs-12 col-sm-0 text-align-center">
                        <LogoContainer internalPage={false} showLogoOnRegistrationScreens={showLogoOnRegistrationScreens} />
                    </div>
                )}
                <div className="dialog-billing-info large-dialog-scroll">
                    {props.addHeader && <h2 className="padding-bottom-s">Terms of Use</h2>}
                    {parse(removeEUPrivateShieldProvatePolicyLink(props.data.termsAndConditonDetailsContent[0].value), options)}
                </div>
            </div>
        </React.Fragment>
    );
};

export default TermsAndConditionDialog;
